import { useEffect, useState } from "react";

/**
 * Thin orange scroll-progress line pinned to the top of the viewport.
 */
export const ScrollProgress = () => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        let raf = 0;
        const update = () => {
            const scrollTop = window.scrollY;
            const docHeight = document.documentElement.scrollHeight - window.innerHeight;
            const p = docHeight > 0 ? scrollTop / docHeight : 0;
            setProgress(Math.min(1, Math.max(0, p)));
            raf = 0;
        };
        const onScroll = () => {
            if (!raf) raf = requestAnimationFrame(update);
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        update();
        return () => {
            window.removeEventListener("scroll", onScroll);
            if (raf) cancelAnimationFrame(raf);
        };
    }, []);

    return (
        <div
            aria-hidden="true"
            className="fixed top-0 left-0 right-0 z-[60] h-[2px] bg-transparent pointer-events-none"
        >
            <div
                data-testid="scroll-progress"
                className="h-full bg-[#FF5A00]"
                style={{
                    width: `${progress * 100}%`,
                    boxShadow: "0 0 12px rgba(255,90,0,0.6)",
                    transition: "width 60ms linear",
                }}
            />
        </div>
    );
};
